import * as React from 'react';

import {FlashBanner} from 'shells/flash-banner/flash-banner';

type Props = {
    overdueDuration: string;
};

export function InvoiceOverdueBanner(props: Props) {
    return (
        <div className='pb-16 full-width'>
            <FlashBanner type='error' leftAlignContent={true} hasBorder={true} animate={false}>
                <div className='flex justify-sb align-center full-width'>
                    This invoice is {props.overdueDuration} overdue.
                </div>
            </FlashBanner>
        </div>
    );
}
